import { type Control, type StoreControl, type TelemetryDataValues, TimeUnitMultiplier } from 'commons';
import type { LineSeriesOption } from 'echarts';
import type { LinesSeriesOption } from 'echarts/types/dist/charts';
import type { SeriesD } from '../types/chart.types';

export class ConfidenceBandSeries {
  /**
   *
   */
  private readonly baseConfig: LineSeriesOption = {
    type: 'line',
    smooth: false,
    connectNulls: false,
    lineStyle: {
      opacity: 0,
    },
    symbol: 'none',
  };
  /**
   * get areaStyle when dir max is set
   */
  private get areaStyle() {
    return this.overwrite.direction === 'Max'
      ? {
          areaStyle: {
            color: `${this.overwrite.control.color}EE`,
          },
        }
      : undefined;
  }
  /**
   *
   */
  private get stack() {
    return {
      stack: `confidence-band-${this.overwrite.control.id}-${this.overwrite.series.xAxisIndex}/${this.overwrite.series.yAxisIndex}`,
    };
  }
  /**
   *
   */
  private get data() {
    return {
      data: this.fillSeriesToResolutionWithNull(
        this.overwrite.telemetryValues.map((tv) => [
          new Date(tv.datetime), // First Dimension === datetime
          this.overwrite.direction === 'Min' // Second Dimension === min or max values
            ? (tv[this.overwrite.control.min_label] as number)
            : this.calcMax(tv[this.overwrite.control.max_label], tv[this.overwrite.control.min_label]),
          undefined,
        ]),
        this.overwrite.control
      ),
    };
  }
  /**
   *
   */
  get config(): LineSeriesOption {
    return {
      ...this.baseConfig,
      ...this.areaStyle,
      ...this.stack,
      ...this.data,
      name: `${this.overwrite.control.label} ${this.overwrite.direction}`,
      xAxisIndex: this.overwrite.series.xAxisIndex,
      yAxisIndex: this.overwrite.series.yAxisIndex,
    } as LinesSeriesOption as any;
  }
  /**
   *
   * @param overwrite
   */
  constructor(
    public overwrite: {
      control: Control;
      series: LineSeriesOption;
      telemetryValues: TelemetryDataValues[];
      direction: 'Min' | 'Max';
    }
  ) {}
  /**
   *
   * @param a
   * @param b
   * @returns
   */

  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  private readonly calcMax = (a: any, b: any) => (a > 0 ? a - b : b - a);
  /**
   *
   * @param series
   * @param control
   * @returns
   */
  private fillSeriesToResolutionWithNull(series: SeriesD, control: StoreControl) {
    if (series.length === 0) {
      return [];
    }

    const addArraY: SeriesD = [];

    const filledData = [...series];
    const multiplier = Number(TimeUnitMultiplier[control.windowUnit]);
    // biome-ignore lint/suspicious/useIterableCallbackReturn: spec
    filledData.flatMap((inside, i, all) => {
      const currentTime = (inside[0] as Date).getTime();
      const nextTime = all[i + 1] && (all[i + 1][0] as Date).getTime();
      const diff = nextTime - currentTime;
      if (diff > control.windowSize * multiplier) {
        addArraY.push([new Date(currentTime + control.windowSize * multiplier), null, null]);
      }
    });
    return [...filledData, ...addArraY].sort((a, b) => new Date(a[0]).getTime() - new Date(b[0]).getTime());
  }
}
